export default {
  coffeeData: {
    windBreaker: "Mti wa Kuvunja Upepo",
    horticultureInfo: "Mti wa Kilimo cha bustani",
    shadeTree: "Mti wa Kivuli",
    coffeeVariety: "Aina ya Kahawa",
    coffeeSpecies: "Aina za Kahawa",
    updateWindBreaker: "Sasisha Aina ya Mti wa WindBreaker",
    addWindBreaker: "Ongeza Aina Mpya ya Mti wa WindBreaker",
    updateHorticultureInfo: "Sasisha Aina ya Mti wa HorticultureInfo",
    addHorticultureInfo: "Ongeza Aina Mpya ya Miti ya HorticultureInfo",
    updateShadeTree: "Sasisha kivuliMti Aina ya Mti",
    addShadeTree: "Ongeza Kivuli Kipya Aina ya Mti",
    updateCoffeeVariety: "Sasisha aina ya mti wa kahawa",
    addCoffeeVariety: "Ongeza kahawa Mpya Aina ya Mti",
    deleteVarietyTitle: "Futa Aina",
    deleteVarietyMessage: "Je, una uhakika unataka kufuta Aina mbalimbali?",
    updateCoffeeSpecie: "Sasisha Aina ya Kahawa",
    deleteSpecieTitle: "Futa Aina",
    deleteSpecieMessage: "Je, una uhakika unataka kufuta Spishi?",
    addCoffeeSpecie: "Ongeza aina Mpya ya Kahawa",
    variety: "Tofauti",
    selectVariety: "Chagua Aina",
    deleteCoffeeRecord: "Je, una uhakika unataka kufuta rekodi?",
    deleteCoffeeData: "Futa Data ya Kahawa",
    topicRequired: "Chagua Mada inahitajika",
    coffeeAddSuccess: "Aina ya Kahawa imeongezwa kwa mafanikio.",
    treeTypeSuccess: "Aina ya mti imeongezwa kwa mafanikio.",
    treeTypeUpdateSuccess: "Aina ya mti imesasishwa.",
    coffeeVarietySuccess: "Aina ya kahawa imeongezwa kwa mafanikio.",
    coffeeSpecieSuccess: "Aina ya kahawa imesasishwa.",
    nameRequired: "Jina linahitajika",
    notFound: "Hakuna Data ya Kahawa ya Msimamizi Imepatikana",
  },
  cacaoData: {
    bags: "Mifuko",
    batchVisualIdentification: "Utambuzi wa Visual wa Kikundi",
    boxes: "Masanduku",
    cacao: "Kakao",
    cacaoOverview: "Muhtasari wa Kakao",
    cacaoSpecies: "Aina za Kakao",
    cacaoType: "Aina ya Kakao",
    cacaoVariety: "Aina ya Kakao",
    cacaoWeight: "Uzito wa Kakao",
    deleteCacaoData: "Futa Data ya Kakao",
    deliveryMethod: "Njia ya Uwasilishaji",
    fermentationPercentage: "Asilimia ya Uchachuaji",
    fermetationMethod: "Njia ya Uchachuaji",
    finalWeight: "Uzito wa Mwisho",
    initialWeight: "Uzito wa Awali",
    performance: "Utendaji",
    piles: "Rundo",
    productPricePerKg: "Bei kwa Kila KG",
    productType: "Aina ya Bidhaa",
    productWeight: "Uzito wa Bidhaa",
    registerFermentation: "Sajili Uchachuaji",
    selectPlantation: "Chagua Shamba",
    selectZone: "Chagua Eneo",
    totalPrice: "Jumla ya Bei",
  },
  memberDataSection: {
    import: "Ingiza",
    buyingStation: "Kituo cha Kununua",
    continue: "Endelea",
    farmerId: "Kitambulisho cha Mkulima",
    farmerName: "Jina la Mkulima",
    farmerAddress: "Anwani ya Mkulima",
    quality: "Ubora",
    quantity: "Kiasi",
    importAll: "Ingiza Zote",
    importSelected: "Uagizaji Umechaguliwa",
    selectCrop: "Chagua Mazao",
    fileLoaded: "Faili imepakiwa",
    incorrectHeaders: "Vijajuu visivyo sahihi",
    processingBatch: "Kundi la usindikaji",
    purchaseOrder: "Agizo la Ununuzi",
    startDate: "Tarehe ya Kuanza",
    endDate: "Tarehe ya mwisho",
    purchasingOrder: "Agizo la Ununuzi",
    totalCoffeeCherry: "Jumla ya Cherry ya Kahawa",
    airHumidity: "Unyevu wa Hewa",
    density: "Msongamano",
    temperature: "Halijoto",
    beanMoistureContent: "Maudhui ya Unyevu wa Maharage",
    processType: "Aina ya Mchakato",
    batchRating: "Chagua Ukadiriaji wa Kundi",
    purchaseDate: "Tarehe ya Kununua",
    selectFarmer: "Chagua Mkulima",
    selectFarm: "Chagua Shamba",
    selectPlantation: "Chagua Upandaji miti",
    coffeeVariety: "Aina ya Kahawa",
    coffeeSpecies: "Aina za Kahawa",
    coffeeCherryQuantity: "Kiasi cha Cherry ya Kahawa",
    coffeeCherryQuality: "Ubora wa Cherry ya Kahawa",
    coffeeType: "Aina ya Kahawa",
    pricePerKg: "Bei Kwa Kg",
    processingDone: "Usindikaji Umekamilika",
    processedCoffeeOut: "Kahawa Iliyochakatwa",
    farmer: "Mkulima",
    farm: "Shamba",
    plantation: "Upandaji miti",
    farmers: "Wakulima",
    farmLimitUsed: "Kikomo cha Kilimo Kimetumika",
    phoneNumber: "Nambari ya simu",
    farmSize: "Ukubwa wa Shamba",
    farmLocation: "Shamba/Mahali",
    date: "Tarehe",
    status: "Hali",
    noFarmers: "Hakuna Wakulima Waliopatikana",
    approveReject: "Idhinisha/Kataa",
    farms: "Mashamba",
    crops: "Mazao",
    equipment: "Vifaa",
    noFarms: "Hakuna Mashamba Yaliyopatikana",
    views: "Tazama",
    selectStatus: "Chagua Hali",
    approved: "Imeidhinishwa",
    rejected: "Imekataliwa",
    reject: "Kataa",
    approve: "Idhinisha",
    cancel: "Ghairi",
    add: "Ongeza",
    describeYourReason: "Eleza sababu yako hapa",
    userInformation: "Taarifa za Mtumiaji",
    userFarmRequest: "Ombi la Shamba la Mtumiaji",
    userFarmInformation: "Taarifa za Shamba la Watumiaji",
    activity: "Shughuli",
    activityType: "Aina ya Shughuli",
    farmZone: "Eneo la Shamba",
    farmerView: "Mtazamo wa Mkulima",
    cropType: "Aina ya Mazao",
    cropVarity: "Tofauti ya Mazao",
    area: "Eneo",
    cost: "Gharama",
    geofence: "Geofence",
    map_views: "Mwonekano wa Ramani",
    viewAllFarms: "Tazama Mashamba Yote",
    farmersDetails: "Maelezo ya Mkulima",
    download: "Pakua",
    pOrder: {
      addNew: "Ongeza Mpya",
      viewAll: "Ona Zote",
      selectDate: "Chagua tarehe",
      makeSelection: "Fanya chaguo",
      coffeeType: "Aina ya kahawa",
      enterPrice: "Ingiza bei",
      reqPurchaseDate: "Tarehe ya ununuzi inahitajika",
      reqFarmer: "Mkulima anahitajika",
      reqCoffeeQnty: "Kiasi cha Kahawa ya Cherry kinahitajika",
      reqPrice: "Bei kwa Kilo kinahitajika",
      grandTotal: "JUMLA KUBWA",
      selectDateRange: "Chagua Kipindi cha Tarehe",
      import: "Import",
      purchaseId: "Nunua Idadi",
      purchaseDate: "Tarehe ya Ununuzi",
      farmerName: "Jina la Mkulima",
      quality: "Ubora",
      quantity: "Kiasi",
      pricePerKg: "Bei kwa Kilo",
      selectBuyingStation: "Chagua kituo cha ununuzi",
      searchUser: "tafuta mtumiaji",
    },
    dateOfEntry: "Tarehe ya Kuingia",
    farmActivities: "Shughuli za Shamba",
    farmActivity: "Shughuli ya Shamba",
    farmDetails: "Maelezo ya Shamba",
    farmID: "Kitambulisho cha Shamba",
    farmInformation: "Taarifa za Shamba",
    goalType: "Aina ya Lengo",
    locationAddress: "Anwani ya Mahali",
    ownershipType: "Aina ya Umiliki",
    selectFarmZone: "Chagua Eneo/Shamba",
    showOnMap: "Onyesha kwenye Ramani",
    totalCost: "Gharama Jumla",
    totalFarmArea: "Eneo Jumla la Shamba",
    totalFarmsRegistered: "Jumla ya Mashamba Yalisajiliwa",
    totalSize: "Ukubwa Jumla",
    totalZone: "Jumla ya Eneo",
    zone: "Eneo",
    zones: "Maeneo",
  },
};
